import React from 'react';
import { CreditCard } from 'lucide-react';
import { PAYPAL_HOME_BANNER_TEXT } from '../utils/paypalEligibility';

/**
 * Static info banner advertising PayPal-Ratenzahlung — no clickable CTA.
 * The eligible products carry their own "PayPal-Ratenzahlung möglich" badge
 * in the listings.
 */
const PayPalInstallmentBanner = ({ className = '' }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl border-2 border-blue-200 bg-gradient-to-r from-blue-50 via-white to-blue-50 ${className}`}
      data-testid="paypal-installment-banner"
    >
      <div className="flex items-start gap-4 p-5 sm:p-6">
        <div className="hidden sm:flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 flex-shrink-0">
          <CreditCard className="text-blue-700" size={24} />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <span className="inline-flex items-center px-2 py-0.5 rounded-md bg-blue-700 text-white text-xs font-bold tracking-wide">
              NEU
            </span>
            <span className="text-xs font-semibold text-blue-700 uppercase tracking-wider">
              PayPal-Ratenzahlung
            </span>
          </div>
          <p className="text-sm sm:text-base font-semibold text-gray-900 leading-snug">
            {PAYPAL_HOME_BANNER_TEXT}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Einkaufsbeträge bis 10.000 €. Nur für Privatkunden mit Privat-PayPal-Konto. Vorbehaltlich Prüfung durch PayPal.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PayPalInstallmentBanner;
